module.exports = __webpack_public_path__ + "static/img/pdf.0cd7f4e1.png";